import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UrlService {
  // https://medium.com/@jacobneterer/accessing-the-previous-url-in-angular-32cf97bec3ce
  private previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>(
    null
  );
  public previousUrl$: Observable<string> = this.previousUrl.asObservable();

  constructor() { }

  setPreviousUrl(previousUrl: string): void {
    this.previousUrl.next(previousUrl);
  }
}
